(function(){
  var root = document.querySelector('[data-spp]');
  if (!root || !window.SP_DATA) return;

  var D = window.SP_DATA;
  var ANGLES = ['正面', '側面', '背面'];

  function shotsFor(colour) {
    var out = [];
    ANGLES.forEach(function (a) {
      for (var i = 0; i < D.media.length; i++) {
        var m = D.media[i];
        if (m.alt && m.alt.indexOf(colour) > -1 && m.alt.indexOf(a) > -1) {
          out.push({ src: m.src, angle: a });
          break;
        }
      }
    });
    if (!out.length && D.media.length) out.push({ src: D.media[0].src, angle: '' });
    return out;
  }

  var stage    = root.querySelector('[data-spp-stage]');
  var dotsBox  = root.querySelector('[data-spp-dots]');
  var angleOut = root.querySelector('[data-spp-angle]');
  var thumbs   = [].slice.call(root.querySelectorAll('[data-spp-thumb]'));
  var colourBtns = [].slice.call(root.querySelectorAll('[data-spp-colour]'));
  var sizeBtns   = [].slice.call(root.querySelectorAll('[data-spp-size]'));
  var idInput  = root.querySelector('[data-spp-id]');
  var addBtn   = root.querySelector('[data-spp-add]');
  var nowOut   = root.querySelector('[data-spp-now]');
  var wasOut   = root.querySelector('[data-spp-was]');
  var saveOut  = root.querySelector('[data-spp-save]');
  var stockOut = root.querySelector('[data-spp-stock]');

  var colour = D.initial.colour;
  var size   = D.initial.size;
  var shots  = [];
  var idx    = 0;

  function money(cents) {
    return 'NT$' + (cents / 100).toLocaleString('zh-TW');
  }

  function renderShots() {
    shots = shotsFor(colour);
    idx = 0;
    stage.querySelectorAll('.spp-shot').forEach(function (n) { n.remove(); });
    dotsBox.innerHTML = '';
    shots.forEach(function (s, n) {
      var img = document.createElement('img');
      img.className = 'spp-shot' + (n === 0 ? ' is-on' : '');
      img.src = s.src;
      img.alt = D.title + ' ' + colour + ' ' + s.angle;
      img.loading = n === 0 ? 'eager' : 'lazy';
      stage.insertBefore(img, stage.firstChild);
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'spp-dot' + (n === 0 ? ' is-on' : '');
      d.setAttribute('aria-label', s.angle || String(n + 1));
      d.addEventListener('click', function () { show(n); });
      dotsBox.appendChild(d);
    });
    show(0);
  }

  function show(n) {
    if (!shots.length) return;
    idx = (n + shots.length) % shots.length;
    var imgs = stage.querySelectorAll('.spp-shot');
    var dots = dotsBox.querySelectorAll('.spp-dot');
    imgs.forEach(function (im, k) { im.classList.toggle('is-on', k === idx); });
    dots.forEach(function (d, k) { d.classList.toggle('is-on', k === idx); });
    if (angleOut) angleOut.textContent = shots[idx].angle || '';
  }

  function variantFor(c, s) {
    for (var i = 0; i < D.variants.length; i++) {
      var v = D.variants[i];
      if (v.options[0] === c && v.options[1] === s) return v;
    }
    return null;
  }

  function sizeAvailable(s) {
    var v = variantFor(colour, s);
    return !!(v && v.available);
  }

  function sync() {
    thumbs.forEach(function (t) {
      t.classList.toggle('is-on', t.getAttribute('data-spp-thumb') === colour);
    });
    colourBtns.forEach(function (b) {
      b.classList.toggle('is-on', b.getAttribute('data-spp-colour') === colour);
    });
    sizeBtns.forEach(function (b) {
      var s = b.getAttribute('data-spp-size');
      b.classList.toggle('is-on', s === size);
      b.classList.toggle('is-off', !sizeAvailable(s));
    });

    var v = variantFor(colour, size);
    if (v) {
      idInput.value = v.id;
      nowOut.textContent = money(v.price);
      if (v.compare && v.compare > v.price) {
        wasOut.textContent = money(v.compare);
        wasOut.hidden = false;
        saveOut.textContent = '早鳥省 ' + ((v.compare - v.price) / 100).toLocaleString('zh-TW');
        saveOut.hidden = false;
      } else {
        wasOut.hidden = true;
        saveOut.hidden = true;
      }
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? D.labels.add : D.labels.sold;
      if (stockOut) stockOut.textContent = v.available ? D.labels.stock : '';
    }
  }

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      colour = t.getAttribute('data-spp-thumb');
      renderShots(); sync();
    });
  });
  colourBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      colour = b.getAttribute('data-spp-colour');
      renderShots(); sync();
    });
  });
  sizeBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      size = b.getAttribute('data-spp-size');
      sync();
    });
  });

  var prev = root.querySelector('[data-spp-prev]');
  var next = root.querySelector('[data-spp-next]');
  if (prev) prev.addEventListener('click', function () { show(idx - 1); });
  if (next) next.addEventListener('click', function () { show(idx + 1); });

  var qty = root.querySelector('[data-spp-qty]');
  var minus = root.querySelector('[data-spp-minus]');
  var plus = root.querySelector('[data-spp-plus]');
  if (minus) minus.addEventListener('click', function () {
    qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1);
  });
  if (plus) plus.addEventListener('click', function () {
    qty.value = (parseInt(qty.value, 10) || 1) + 1;
  });

  renderShots();
  sync();
})();
